import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-aviso-legal',
  templateUrl: './aviso-legal.component.html',
  styleUrls: ['./aviso-legal.component.scss']
})
export class AvisoLegalComponent implements OnInit {

  constructor(private location: Location) { }

  ngOnInit(): void {
  }

  irAUrlAnterior() {
    this.location.back();
  }

}
